const _overrides: Map<string, string> = new Map();

export const registerEndpoint = (key: string, url: string): void => {
  _overrides.set(key, url);
};

export const resolveEndpoint = (key: string, defaultUrl: string): string => {
  return _overrides.get(key) ?? defaultUrl;
};
